import { gql } from 'graphql-request';
import {
  MaterialBlocked,
  MaterialBrandID,
  MaterialBrandName,
  MaterialCategoryID,
  MaterialCategoryName,
  MaterialClientCurrentTeamNanoId,
  MaterialClientFullName,
  MaterialClientID,
  MaterialClientNanoId,
  MaterialFavorite,
  MaterialID,
  MaterialImageFile,
  MaterialImageID,
  MaterialImageName,
  MaterialImageSize,
  MaterialImageUUID,
  MaterialMaxFileCreatedAt,
  MaterialMaxFileFile,
  MaterialMaxFileID,
  MaterialMaxFileName,
  MaterialMaxFileSize,
  MaterialMaxFileUUID,
  MaterialName,
  MaterialNanoID,
  MaterialNda,
  MaterialSku,
  MaterialTeamID,
  MaterialTeamName,
  MaterialTeamNanoId,
  MaterialTeamUUID,
  MaterialUUID,
  MaterialProductID,
  MaterialLifestyleID
} from '../materialsTypes';

export interface CacheFetchShowMaterialQueryResponseImage {
  id: MaterialImageID;
  uuid: MaterialImageUUID;
  file: MaterialImageFile;
  size: MaterialImageSize;
  name: MaterialImageName;
}

export interface CacheFetchShowMaterialQueryResponseMaxFile {
  id: MaterialMaxFileID;
  uuid: MaterialMaxFileUUID;
  file: MaterialMaxFileFile;
  size: MaterialMaxFileSize;
  name: MaterialMaxFileName;
}

export interface CacheFetchShowMaterialQueryResponse {
  id: MaterialID;
  nanoId: MaterialNanoID;
  uuid: MaterialUUID;
  name: MaterialName;
  sku: MaterialSku;
  nda: MaterialNda;
  image: CacheFetchShowMaterialQueryResponseImage;
  images?: CacheFetchShowMaterialQueryResponseImage[];
  maxFile: {
    createdAt: MaterialMaxFileCreatedAt;
  };
  maxFiles?: CacheFetchShowMaterialQueryResponseMaxFile[];
  favorite: MaterialFavorite;
  blocked: MaterialBlocked;
  categories?: {
    id: MaterialCategoryID;
    localizedName: MaterialCategoryName;
  }[];
  brand?: {
    id: MaterialBrandID;
    localizedName: MaterialBrandName;
  };
  clients: {
    id: MaterialClientID;
    nanoId: MaterialClientNanoId;
    fullName: MaterialClientFullName;
    currentTeam: {
      nanoId: MaterialClientCurrentTeamNanoId;
    };
  }[];
  teams: {
    id: MaterialTeamID;
    uuid: MaterialTeamUUID;
    nanoId: MaterialTeamNanoId;
    name: MaterialTeamName;
  }[];
  products?: {
    id: MaterialProductID;
  }[];
  lifestyles?: {
    id: MaterialLifestyleID;
  }[];
}

export const CACHE_FETCH_SHOW_MATERIAL_QUERY = gql`
  query CacheShowMaterial($uuid: ID!, $source: String) {
    material(uuid: $uuid, source: $source) {
      id
      nanoId
      uuid
      name
      sku
      nda
      favorite
      blocked
      categories {
        id
        localizedName
      }
      brand {
        id
        localizedName
      }
      image {
        id
        uuid
        size
        name
        file
      }
      images {
        id
        uuid
        file
        size
        name
      }
      maxFile {
        createdAt
      }
      maxFiles {
        id
        uuid
        file
        size
        name
      }
      teams {
        id
        nanoId
        uuid
        name
      }
      products {
        id
      }
      lifestyles {
        id
      }
    }
  }
`;
